module.exports = __webpack_public_path__ + "static/media/search.722a8e1a.svg";